export const HTML_ERROR_FALLBACK_MESSAGE = 'ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง';

export function isHtmlErrorMessage(value: string): boolean {
  const trimmedValue = value.trim().toLowerCase();

  return (
    trimmedValue.startsWith('<!doctype html') ||
    trimmedValue.startsWith('<html') ||
    /<\/?(html|head|body|title|style|script|pre)(\s|>|\/)/i.test(value)
  );
}

export function getSafeErrorText(value: unknown): string {
  if (typeof value !== 'string') {
    return '';
  }

  const message = value.trim();

  if (message === '') {
    return '';
  }

  return isHtmlErrorMessage(message) ? HTML_ERROR_FALLBACK_MESSAGE : message;
}

export function getApiErrorMessage(
  error: unknown,
  fallback = 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง',
): string {
  const body = error !== null && typeof error === 'object' && 'error' in error
    ? (error as { error?: unknown }).error
    : error;

  if (body !== null && typeof body === 'object') {
    const payload = body as { message?: unknown; error?: unknown; errors?: unknown };
    if (Array.isArray(payload.errors)) {
      const messages = payload.errors.map(getSafeErrorText).filter(Boolean);
      if (messages.length > 0) {
        return messages.join('\n');
      }
    }

    const message = getSafeErrorText(payload.message) || getSafeErrorText(payload.error);
    if (message !== '') {
      return message;
    }
  }

  return getSafeErrorText(body) || fallback;
}
